import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="navbar" data-testid="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="brand-logo" data-testid="brand-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_5b74c3d6-2b7f-4f5e-8a02-125e94fc2ed0/artifacts/ko7e8eh7_1000002309-removebg-preview.png" 
              alt="ClutchBabe9" 
              className="brand-logo-img"
            />
            <span className="brand-text">ClutchBabe9</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="nav-links desktop-nav" data-testid="desktop-nav">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link 
              to="/blog" 
              className={`nav-link ${isActive('/blog') ? 'active' : ''}`}
              data-testid="nav-blog"
            >
              Blog
            </Link>
            <Link 
              to="/videos" 
              className={`nav-link ${isActive('/videos') ? 'active' : ''}`}
              data-testid="nav-videos"
            >
              Videos
            </Link>
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              data-testid="nav-about"
            >
              About
            </Link>
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
              data-testid="nav-contact"
            >
              Contact
            </Link>
            <Link 
              to="/admin/login" 
              className="nav-link admin-nav-link"
              data-testid="nav-admin"
            >
              🔐 Admin
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn" 
            onClick={toggleMenu}
            aria-label="Toggle menu"
            data-testid="mobile-menu-btn"
          >
            <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Nav */}
        {isMenuOpen && (
          <nav className="nav-links mobile-nav" data-testid="mobile-nav">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/blog" 
              className={`nav-link ${isActive('/blog') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <Link 
              to="/videos" 
              className={`nav-link ${isActive('/videos') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Videos
            </Link>
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <Link 
              to="/admin/login" 
              className="nav-link admin-nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              🔐 Admin Login
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}

export default Navbar;
